import * as appConstants from "../../infrastructure/appConstants";

export const tipoDocumentoOptions = [
  { key: "1", text: "DNI", value: appConstants.CODIGO_TIPO_DOCUMENTO_DNI },
  {
    key: "2",
    text: "Carnet de Extranjería",
    value: appConstants.CODIGO_TIPO_DOCUMENTO_CCEE,
  },
  {
    key: "3",
    text: "Pasaporte",
    value: appConstants.CODIGO_TIPO_DOCUMENTO_PASP,
  },
  { key: "4", text: "RUC", value: appConstants.CODIGO_TIPO_DOCUMENTO_RUC },
  {
    key: "5",
    text: "Otros(Cart.Ide.-Ced.Iden - PN)",
    value: appConstants.CODIGO_TIPO_DOCUMENTO_OTRS,
  },
  {
    key: "6",
    text: "Carnet Permiso Temporal de Permanencia",
    value: appConstants.CODIGO_TIPO_DOCUMENTO_PTP,
  },
  {
    key: "7",
    text: "Cédula de Identidad o documentos análogos",
    value: appConstants.CODIGO_TIPO_DOCUMENTO_CI,
  },
  {
    key: "8",
    text: "Carnet de Refugiado",
    value: appConstants.CODIGO_TIPO_DOCUMENTO_CR,
  },
  {
    key: "9",
    text: "Documento expedido por la CEPR del Ministerio de RREE",
    value: appConstants.CODIGO_TIPO_DOCUMENTO_CEPR,
  },
];

export const metodoVerificacionOptions = [
  {
    key: "1",
    text: "EMAIL",
    value: appConstants.CODIGO_METODO_VERIFICACION_EMAIL,
  },
];

export const metodoPagoOptions = [
  {
    key: "1",
    text: appConstants.DESCRIPCION_METODO_PAGO_CULQI,
    value: appConstants.CODIGO_METODO_PAGO_CULQI,
  },
  {
    key: "2",
    text: appConstants.DESCRIPCION_METODO_PAGO_CUENTA_AHORROS,
    value: appConstants.CODIGO_METODO_PAGO_CUENTA_AHORROS,
  },
];

export const tipoMonedaOptions = [
  {
    key: "1",
    value: appConstants.CODIGO_MONEDA_SOLES,
    text: appConstants.DESCRIPCION_MONEDA_SOLES,
  },
  {
    key: "2",
    value: appConstants.CODIGO_MONEDA_DOLARES,
    text: appConstants.DESCRIPCION_MONEDA_DOLARES,
  },
];

export const aperturaDPFPlazoOptions = [
  { key: "1", value: 30, text: "30 días" },
  { key: "2", value: 90, text: "90 días" },
  { key: "3", value: 120, text: "120 días" },
  { key: "4", value: 180, text: "180 días" },
  { key: "5", value: 360, text: "360 días" },
  { key: "6", value: 540, text: "540 días" },
  { key: "7", value: 720, text: "720 días" },
];
